/** Try it: the page working as people will use it — its bar, Find anything's ways in, and the drawer of data and problems under it. */
export const tryIt = {
  design: 'Design',
  tryIt: 'Try it',
  modes: 'Design or try the page',
  tryThePage: 'Try the page',
  width: 'Width',
  sizes: { desktop: 'Desktop', tablet: 'Tablet', phone: 'Phone' },
  note: 'The page works as people will use it. Nothing typed here is kept.',
  /** Try it while the last change is refused: what it shows instead, and why. */
  lastPassed: (why: string) => `Try it shows the page as it was before your last change, which the page cannot take: ${why}`,
  language: 'Language',
  wordsIn: 'Words in',
  // ---- Find anything
  backToDesigning: 'Back to designing',
  asPeopleWillUseIt: 'as people will use it',
  atPhoneWidth: 'Try it at a phone’s width',
  inArabic: 'Try it in Arabic, right to left',
  // ---- the drawer
  drawer: 'Data and problems',
  data: 'Data',
  problems: 'Problems',
  /** Required questions not answered yet, said neutrally: no problem until the page is sent. */
  toAnswer: '{n} to answer',
  copyData: 'Copy data',
  answersAsJson: 'The answers as JSON',
  nothingInTheWay: 'Nothing stands in the way of sending this.',
  show: 'Show',
  hide: 'Hide',
  copied: 'Copied.',
  selected: 'Selected: copy it with the keyboard.',
};
